import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const navCenter = [
  { to: '/', label: '首页' },
  ...categories.map((c) => ({ to: `/category/${c.slug}`, label: c.name })),
  { to: '/about', label: '关于我们' },
];

export default function SiteHeader({ logoHeading = false }: { logoHeading?: boolean }) {
  const [open, setOpen] = useState(false);

  const Logo = (
    <Link to="/" onClick={() => setOpen(false)} className="flex items-center gap-2.5" aria-label="每日大瓜首页">
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
        瓜
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-label text-lg font-extrabold tracking-tight text-foreground-950">每日大瓜</span>
        <span className="text-[11px] font-medium tracking-wide text-foreground-500">全网吃瓜时间线</span>
      </span>
    </Link>
  );

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      {/* ticker */}
      <div className="border-b border-background-200/70 bg-secondary-100/70">
        <div className="mx-auto flex max-w-6xl items-center gap-2 px-4 md:px-6 py-1.5 text-xs text-secondary-900">
          <span className="inline-flex shrink-0 items-center gap-1 font-semibold text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            今日瓜田
          </span>
          <span className="truncate text-secondary-700">
            正在热议：番位之争录音两版流出 · 选秀冠军恋情乌龙反转 · 音乐节压轴位博弈
          </span>
        </div>
      </div>

      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 md:px-6 py-3">
        {logoHeading ? <h1 className="m-0">{Logo}</h1> : Logo}

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navCenter.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-primary-700'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/about"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-notification-3-line mr-1.5 text-base" aria-hidden="true" /> 追瓜提醒
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-800 hover:bg-background-100 lg:hidden"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'} />
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden" aria-label="移动导航">
          <div className="grid grid-cols-2 gap-2">
            {navCenter.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}